import { palette } from "./settings";

export const MuiAppBar = {
  colorPrimary: {
    backgroundColor: "#21292F",
    color: palette.common.white
  }
};
